import formConditions from "./formConditions.json";

/**
 * Keeps any truthy values in the starter object and fills any falsy values in
 * starter with the values of filler.
 * @param {Object} starter
 * @param {Object} filler
 */
export function conditionallyAssign(starter, filler) {
    const obj = { ...starter };
    Object.entries(filler).forEach(([key, value]) => {
        if (!starter[key]) obj[key] = value;
    });
    return obj;
}

function replaceUndefined(starter) {
    const obj = { ...starter };
    Object.keys(obj).forEach((key) => {
        if (!starter[key]) obj[key] = "";
    });
    return obj;
}

/**
 *
 * @param {Object} argsForDerivation
 * @param {string} argsForDerivation.domain
 * @param {string} argsForDerivation.vertical
 * @param {string} argsForDerivation.page
 */
export function deriveHardcodedFormData(argsForDerivation) {
    const { domain, vertical, page } = argsForDerivation;
    try {
        const formValues = formConditions[domain][vertical][page];
        return { ...formValues };
    } catch (err) {
        console.warn("Unable to derive hardcoded form data, using US business as a fallback\n", err);
        return {
            omniformname: "corporate",
            importSourceMostRecent1: "US Business Resources Pricing Form",
            CampaignID: "7010W000002b4xX",
            subSector1: ""
        };
    }
}

/**
 * Values for these fields can be fed in as hardcoded props where the GateForm
 * is defined. This method processes those props and adds them to the store. In
 * cases of overlap of importSourceMostRecent1, the direct values take
 * precedent.
 * @param vertical
 */

function setIndustry(vertical) {
    switch (vertical) {
        case "k12":
            return "K-12";
        case "hed":
            return "Higher Education";
        case "pubsec":
            return "Public Sector";
        default:
            return "Corporate";
    }
}
export function processHardcodedFormData(argsForDerivation, directValues) {
    const derivedValues = deriveHardcodedFormData(argsForDerivation);
    const starter = { ...replaceUndefined(directValues) };
    const filler = {
        importSourceMostRecent1: derivedValues.importSourceMostRecent1,
        omniformname: derivedValues.omniformname,
        CampaignID: derivedValues.CampaignID,
        subSector1: derivedValues.subSector1,
        Industry: setIndustry(argsForDerivation.vertical)
    };
    return conditionallyAssign(starter, filler);
}
